<template>

    <div class="report_in_gen button is-outlined is-info">
        <IconLoader class="icon_loader" />
        Rapports en cours de génération
    </div>

</template>

<script>
export default {
    name: 'ReportInGen'
}
</script>

<style lang="scss" >
.report_in_gen{
    display: flex;
    align-items: center;
    color: $info!important;
    .icon_loader {
        width: 25px;
    }
    &:hover{
        background: white!important;
        color: $danger!important;
        cursor: not-allowed;
    }
}
</style>